import { useMutation, useQueryClient } from "react-query";
import React from "react";
import * as wf from "@qpr/client-api-workflow";
import { WFDelegateParams } from "@qpr/client-api-workflow/types";

const useSubmitDelegateTask = () => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  // was: types.MeasurePayload

  return useMutation(async (params: WFDelegateParams) => {
    return wf.delegate(params);
  }, invalidateCache);
};

export default useSubmitDelegateTask;
